module.exports = __webpack_public_path__ + "img/tp3.91a2d259.png";